import { useMutation, UseMutationResult } from "@tanstack/react-query";
import {
	UpdateGuestFormRequest,
	updateGuestRegistrationForm,
} from "@/api/register.ts";
import { RequestError } from "@/axios/schema.ts";

const useUpdateGuestForm = (
	locationId: number,
): UseMutationResult<void, RequestError, UpdateGuestFormRequest> => {
	return useMutation({
		mutationFn: async (payload: UpdateGuestFormRequest) =>
			await updateGuestRegistrationForm(payload, locationId),
	});
};

export default useUpdateGuestForm;
